import styled from "styled-components";

const Container = styled.section`
  width: 100%;

  .map-toggle-row {
    display: flex;
    justify-content: flex-end;
    margin-bottom: ${({isOpen}) => isOpen ? "10px" : "0"};
  }

  .map-toggle-button {
    height: 36px;
    padding: 0 18px;
    border: 1px solid ${({theme}) => theme.mainBorderColor};
    border-radius: 9px;
    background: ${({theme}) => theme.secondaryBgColor};
    color: ${({theme}) => theme.mainTextColor};
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-lg);
    cursor: pointer;
  }
`;

const CollapsibleTopMap = ({isOpen, onToggle, children}) => (
  <Container isOpen={isOpen}>
    <div className="map-toggle-row">
      <button type="button" className="map-toggle-button" onClick={onToggle}>
        Haritayı {isOpen ? "Gizle" : "Göster"}
      </button>
    </div>
    {isOpen && children}
  </Container>
);

export default CollapsibleTopMap;
